import { faGithub, faLinkedin, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaChevronCircleUp } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { Context } from "../../context";
import classes from "./Footer.module.css";

const Footer = () => {
  const parse = require("html-react-parser");
  const [data, setData] = useState([]);
  const [error, setError] = useState([]);

  const { debug, linkedin, github, lang, youtube } = useContext(Context);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <Container fluid={true} className={classes.Section}>
        <Container className={classes.footerContainer}>
          <Row>
            <Col lg="6" md={6} sm={12} className={classes.footerCol1}>
              <h2 className={`${classes.Name} text-left`}>Davide Balice</h2>
              <p className={classes.Description}>
                Full stack web developer
                <br></br>
                {lang === "en" && <>Personal site</>}
                {lang === "it" && <>Sito personale</>}
                <br></br> <br></br>
                <b>Email:</b>
                <br></br>
                davide.balice@gmail.com
              </p>
            </Col>

            <Col lg="6" md={6} sm={12} className={classes.footerCol2}>
              <div className={classes["social-column"]}>
                <h3 className={`${classes.Name} text-left`}>Legal</h3>
                <div className={classes["legal-container"]}>
                  <NavLink to="/privacy" className={classes.legal}>
                    Privacy
                  </NavLink>
                  <br />
                  <NavLink to="/cookie" className={classes.legal}>
                    Cookie
                  </NavLink>
                </div>
              </div>

              <div className={classes["social-column"]}>
                <h3 className={`${classes.Name} text-left`}>Connect</h3>
                <div className={classes["social-container"]}>
                  <a
                    className={classes.social}
                    href={linkedin}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={faLinkedin} size="2x" />
                  </a>
                  <a
                    className={classes.social}
                    href={github}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={faGithub} size="2x" />
                  </a>

                  <a
                    className={classes.social}
                    href={youtube}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={faYoutube} size="2x" />
                  </a>


                  


                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Container fluid={true} className={`${classes.copyright} text-center`}>
        <p> </p>
        <p className={classes.copyrightlink}>© Copyright Davide Balice</p>
        <p onClick={scrollToTop} className={classes.footerTop}>
          <FaChevronCircleUp /> Top
        </p>
      </Container>
    </>
  );
};

export default Footer;
